<template>
  <div class="container-window mt-3 mr-3 border bd-e4 px-3">
    <HeaderWindow
      @onClose="onClose"
      :title="title"
      :show_calll="true"
    />
    <div class="table-responsive">
      <div class="row mt-2 ml-1">
        <div class="col-sm-2 robo-14-400 txt-pri-corl">Tài liệu: Sinh hoá</div>
        <div class="col-sm-2 robo-14-400 txt-pri-corl">Ngày tải: 20/08/2021</div>
        <div class="col-sm-4 robo-14-400 txt-pri-corl">Người cập nhật: Nguyễn Văn A (Bác sĩ)</div>
      </div>
      <table class="table table-vcenter table-mobile-md card-table table-scroll">
        <thead>
          <tr>
            <th><span
                class="ml-sm-2 robo-16-500"
                style="color: #03267A;"
              >Xét nghiệm</span></th>
            <th><span
                class="robo-16-500"
                style="color: #03267A;"
              >Kết luận</span></th>
            <th><span
                class="robo-16-500"
                style="color: #03267A;"
              >Mô tả</span></th>
            <th><span
                class="robo-16-500"
                style="color: #03267A;"
              >Ngày chẩn đoán</span></th>
          </tr>
        </thead>
        <tbody>
          <tr class="mt-2 mb-2 border-bottom">
            <td data-label="Xét nghiệm"><span class="robo-16-500 txt-black-gray ml-sm-2">Siêu âm tim</span></td>
            <td data-label="Kết luận">
              <pre
                class="border-0 robo-16-500 txt-black-gray ff-robo"
                style="background-color: transparent; padding: 0;"
              >1. Van hai lá: kiểu di động ngược chiều
2. Van đọn mach chủ: là ván thanh mảnh ...</pre>
            </td>
            <td data-label="Mô tả">
              <pre
                class="border-0 robo-16-500 txt-black-gray ff-robo"
                style="background-color: transparent; padding: 0;"
              >1. Van hai lá: kiểu di động ngược chiều
2. Van đọn mach chủ: là ván thanh mảnh ...</pre>
            </td>
            <td
              data-label="Ngày chẩn đoán"
              class="robo-16-500"
            >
              <pre
                class="border-0 robo-16-500 txt-black-gray ff-robo"
                style="background-color: transparent; padding: 0;"
              >22/08/2021</pre>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import PersonProfile from '../../components/Diseases/PersonProfile.vue'
import HeaderWindow from '../../components/Diseases/HeaderWindow.vue'
import TypeBar from '../../components/Diseases/TypeBar.vue'
export default {

  name: 'BloodCountTest',
  components: { PersonProfile, HeaderWindow, TypeBar },
  data () {
    return {
      title: 'Xét nghiệm công thức máu',
      person_diseases_id: '',
      current_page: 1
    }
  },
  mounted () {
    let self = this
    self.person_diseases_id = self.$route?.params?.id
  },
  methods: {
    onClose () {
      this.$router.push({ path: `/doctor/diseases/${this.$route?.params?.id}` })
    },
    formatDateDMY (date) {
      return window.moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
<style lang="css" scoped>
.btn-type-date {
  min-width: 95px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-right: 1px solid;
}

.vc-container {
  border: 0 !important;
}

a:hover {
  text-decoration: none;
}

.border-bottom-width-2 {
  border-bottom: solid 1.5px;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}
</style>